import { Spin, Table } from 'antd'

import { Modal } from '@suntex.fim/ui'

import { Button } from '../Button/Button'

type PlayerActivityModalProps = {
  isModalOpen: boolean
  handleOk: () => void
  handleCancel: () => void
  dataSource: {
    key: string
    game: string
    stickers: number
    played: string
    image: string
  }[]
  columns: (
    | {
        title: string
        dataIndex: string
        key: string
        render: (text: string, record: any) => JSX.Element
      }
    | {
        title: string
        dataIndex: string
        key: string
        render?: undefined
      }
  )[]
  count: number | undefined
  isLoading: boolean
}

/**
 * returns JSX for bubble modal
 */
export function PlayerActivityModal({
  isModalOpen,
  handleOk,
  handleCancel,
  dataSource,
  columns,
  count,
  isLoading
}: PlayerActivityModalProps) {
  return (
    <Modal
      title="Recent Player Activity"
      width={686}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="add-player"
      footer={
        <Button
          shape="round"
          intent="primary"
          key="submit"
          onClick={() => {
            handleOk()
          }}
        >
          Okay
        </Button>
      }
    >
      {isLoading ? (
        <div className="table-info__desc">
          <Spin />
        </div>
      ) : (
        <>
          <Table
            className="player-activity-table"
            dataSource={dataSource}
            columns={columns}
          />
          <div className="table-info__desc">
            Showing most recent{' '}
            <span className="fw-bold">{dataSource.length}</span> of{' '}
            <span className="fw-bold">{count}</span> total activity records.
          </div>
        </>
      )}
    </Modal>
  )
}
